import Cookies from 'js-cookie';

/****** KMS alerts ******/
export function runAlerts(){
    //First hide all the alerts. We will then re-display those that the user hasn't closed.
    var alerts = Array.from(document.querySelectorAll(".alert"));
    alerts.forEach(alert => alert.style.display = 'none');    
    var seen = Cookies.get('alerts-closed');
    alerts.forEach((alert)=>{        
        if (alert.classList.contains('alert-message') || !seen || seen.indexOf(alert.dataset.id) == -1) {
            alert.style.display = '';
            var closer = alert.querySelector('.close');
            closer.addEventListener('click',()=>
                {
                    if (!alert.classList.contains('alert-message')) {
                        if (!seen) seen = "";
                        seen = seen +','+ alert.dataset.id;
                        Cookies.set('alerts-closed',seen, { expires: 1000 });
                    }
                    alert.remove();
                    checkOpen();
                }
            );
            closer.style.display='';
        }
        else {
            //Remove hidden alerts from document.
            alert.remove();
        }
    });
    checkOpen();
    function checkOpen(){
        var body = document.getElementsByTagName("body")[0];
        if (document.querySelector(".alert")) {
            body.classList.add('alerts-active');
        } else {
            body.classList.remove('alerts-active');
        }
    }
}